export default "__VITE_ASSET__D6iL4mQ9__"